import React from "react"
import { compose } from "recompose"
import cn from "classnames"

import moment from "moment"
import size from "lodash/size"
import map from "lodash/map"
import get from "lodash/get"

import { Flex } from "@infotech/uikit-grid"
import Accordeon, { AccordeonGroup } from "@infotech/uikit-accordeon"

import withPreparedChecks from "./hocs/withPreparedChecks"
import withPreparedMts from "./hocs/withPreparedMts"
import withPreparedCrew from "./hocs/withPreparedCrew"
import withPreparedDefects from "./hocs/withPreparedDefects"
import withVisits from "../hocs/withVisits"
import Row from "./Row"
import styles from "./styles.css"

const NO_DATA = `(нет данных)`

const PlanAndFact = ({
  preparedChecks,
  preparedMts,
  preparedCrew,
  actualDefects,
  eventData: { startDateTime, endDateTime },
  issue: {
    customFields: {
      date_start_fact: dateStartFact,
      date_end_fact: dateEndFact,
    },
  } = {},
}) => (
  <Flex className={styles.container}>
    <Flex className={cn([styles.header, styles[`with-padding`]])}>
      <div className={styles[`name-column`]}>Наименование</div>
      <div className={styles[`plan-fact-column`]}>План</div>
      <div className={styles[`plan-fact-column`]}>Факт</div>
      <div className={styles[`status-column`]}>Статус</div>
    </Flex>
    <div className={cn([styles.br, styles[`with-bottom-margin`]])} />
    <Flex className={styles[`with-padding`]}>
      <div className={cn([styles[`name-column`]])}>Период события</div>
      <div className={styles[`plan-fact-column`]}>
        <div>{`${moment(startDateTime).format(`D MMMM YYYY, HH:mm`)} — `}</div>
        <div>{`${moment(endDateTime).format(`D MMMM YYYY, HH:mm`)}`}</div>
      </div>
      <div className={styles[`plan-fact-column`]}>
        <div>
          {`${
            dateStartFact
              ? moment(dateStartFact).format(`D MMMM YYYY, HH:mm`)
              : NO_DATA
          } — `}
        </div>
        <div>
          {`${
            dateEndFact
              ? moment(dateEndFact).format(`D MMMM YYYY, HH:mm`)
              : NO_DATA
          }`}
        </div>
      </div>
      <div className={styles[`status-column`]} />
    </Flex>
    <AccordeonGroup
      className={styles[`full-width`]}
      defaultOpenIndexes={[0, 1, 2, 3]}
      independent
    >
      <Accordeon
        className={styles[`full-width`]}
        label="Операции"
        badgeValue={size(preparedChecks)}
      >
        {map(
          preparedChecks,
          ({
            operation,
            description = operation,
            duration = null,
            status,
            planValue = null,
          }) => (
            <Row
              name={description}
              plannedValue={planValue}
              actualValue={duration}
              customStatus={status}
              withStatus
            />
          ),
        )}
      </Accordeon>

      <Accordeon
        className={styles[`full-width`]}
        label="Материалы"
        badgeValue={size(preparedMts)}
      >
        {map(
          preparedMts,
          ({ name, requiredCount, actualCount, materialUnit }) => (
            <Row
              name={name}
              plannedValue={requiredCount}
              actualValue={actualCount}
              unit={get(materialUnit, [`link`, `value`], undefined)}
            />
          ),
        )}
      </Accordeon>

      <Accordeon
        className={styles[`full-width`]}
        label="Бригада"
        badgeValue={size(preparedCrew)}
      >
        {map(
          preparedCrew,
          ({
            firstName,
            lastName,
            patronymic,
            fields: {
              Surname = `${lastName || ``} ${firstName || ``} ${patronymic ||
                ``}`,
              Position,
            } = {},
            positionName = Position,
            planned,
            actual,
          }) => (
            <Row
              name={positionName}
              plannedValue={planned ? Surname : ``}
              actualValue={actual ? Surname : ``}
            />
          ),
        )}
      </Accordeon>

      <Accordeon
        className={styles[`full-width`]}
        label="Дефекты"
        badgeValue={size(actualDefects)}
      >
        {map(actualDefects, ({ defectTypeName, repairDate }) => (
          <Row name={defectTypeName} customStatus={!!repairDate} withStatus />
        ))}
      </Accordeon>
    </AccordeonGroup>
  </Flex>
)

const enhance = compose(
  withVisits,
  withPreparedChecks,
  withPreparedMts,
  withPreparedCrew,
  withPreparedDefects,
)

export default enhance(PlanAndFact)
